export default __webpack_public_path__ + "static/media/WF5.b9a2cbf6.png";